module.exports = __webpack_public_path__ + "img/fingerprint-03.d7ab3c98.svg";